import { render } from "./ProductItemCheckout.vue?vue&type=template&id=556d413a&scoped=true"
import script from "./ProductItemCheckout.vue?vue&type=script&lang=js"
export * from "./ProductItemCheckout.vue?vue&type=script&lang=js"

import "./ProductItemCheckout.vue?vue&type=style&index=0&id=556d413a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556d413a"]])

export default __exports__